export const copyGroups = {
  misc: 'misc',
  blockedProducts: 'blockedProducts',
  errorDialogs: 'errorDialogs',
  deliveryMethods: 'deliveryMethods',
  requestSummary: 'requestSummary',
}

export const copyInputTypes = {
  text: 'text',
  richText: 'richText',
  titleAndTextArea: 'titleAndTextArea',
}

export const getCopyTabs = t => [
  { label: t('Productos bloqueados'), value: copyGroups.blockedProducts },
  { label: t('Diálogos de error'), value: copyGroups.errorDialogs },
  { label: t('Tipos de método de devolución'), value: copyGroups.deliveryMethods },
  { label: t('Resumen solicitud'), value: copyGroups.requestSummary },
  { label: t('Misc.'), value: copyGroups.misc },
]

export const miscPreviewSections = {
  orderNumber: 'start_screen.order_number',
  emailPostcode: 'start_screen.email_postcode',
  variants: 'exchanges.variants',
  otherProducts: 'exchanges.other_products',
  outOfStock: 'exchanges.out_of_stock',
}

export const copyPostMessageTypes = {
  copiesUpdate: 'REVENI_COPIES_UPDATE',
  iframeReady: 'REVENI_IFRAME_READY',
}

export const requestSummaryPreviewSections = {
  instantRefundBankTransfer: 'summary.instant_refund.bank_transfer',
  instantRefundOpm: 'summary.instant_refund.original_payment_method',
  instantRefundGiftCard: 'summary.instant_refund.gift_card',
  instantRefundStoreCredit: 'summary.instant_refund.store_credit',
  refundOpm: 'summary.refund.original_payment_method',
  refundGiftCard: 'summary.refund.gift_card',
  refundStoreCredit: 'summary.refund.store_credit',
  instantExchange: 'summary.instant_exchange',
  exchange: 'summary.exchange',
}
